// extracted by css-extract-rspack-plugin
export default {"root":"Pm9QBJ","viewport":"bcTuIV","swipeable":"QnFq2M","panel":"OiJJ5A","pagination":"U9DdQB"};